<template>
    <div>

        <customer-dash-intro v-if="part.type == 'intro'"
                :part="part"></customer-dash-intro>


        <customer-dash-coupons v-else-if="part.type == 'coupons'"
                :part="part"></customer-dash-coupons>

        <customer-dash-bookings v-else-if="part.type == 'bookings'"
                :part="part"></customer-dash-bookings>

        <customer-dash-queue v-else-if="part.type == 'queue'"
                                :part="part"></customer-dash-queue>

        <customer-dash-locations v-else-if="part.type == 'locations'"
                                :part="part"></customer-dash-locations>

        <div v-else class="panel panel-flat">
            <div class="panel-heading">
                KOMPONENTTYP OREGISTRERAD
            </div>
            <div class="panel-body">
                Okänd komponenttyp:
                <div><b>{{part.title}}</b></div>
                <div><b>{{part.type}}</b></div>
            </div>
        </div>

    </div>

</template>

<script>
    export default {
        props: [
            'part'
        ],
        name: "create-dash-component"
    }
</script>

<style scoped>
.panel.panel-flat {
    margin-bottom: 15px;
}
</style>